import { createAsyncThunk } from '@reduxjs/toolkit';
import { CheckFreeTrialAvailabilityParams } from '../interfaces/free-trial-availability.interface';
import { StoreState } from '../../../store/store.interface';
import { ActionStatus } from '../../../common/constants/action-status';
import { checkFreeTrialAvailabilityGuest } from '../apis/free-trial.api';

export const getFreeTrialAvailabilityGuest = createAsyncThunk(
  'freeTrial/checkAvailabilityGuest',
  async (params: CheckFreeTrialAvailabilityParams, thunkAPI) => {
    try {
      return await checkFreeTrialAvailabilityGuest(params.skus);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
  {
    condition: (_: CheckFreeTrialAvailabilityParams, { getState }) => {
      const state = getState() as StoreState;
      return ActionStatus.idle === state.freeTrialState.freeTrialAvailability.status;
    },
  }
);
